import { api } from '@/api';
import { ActionContext } from 'vuex';
import { IUserProfileUpdate } from '@/interfaces';
import { State } from '../state';
import { OmrState, OmrTaskState, UploadImageState } from './state';
import * as omrStateStore from './vuex';
import { getStoreAccessors } from 'typesafe-vuex';
// import { commitSetUsers, commitSetUser } from './mutations';
import { dispatchCheckApiError } from '../main/actions';
import { commitAddNotification, commitRemoveNotification } from '../main/mutations';

type MainContext = ActionContext<OmrState, State>;

export const actions = {
    async actionGetOmrTaskList(context: MainContext) {
        try {
            const response = await api.getOmrTaskList(context.rootState.main.token);
            if (response) {
                // omrStateStore.commitSetImgList(context, response.data ?? [] as OmrTaskState[]);
                return response.data;
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateUser(context: MainContext, payload: { id: string, user: IUserProfileUpdate }) {
        try {
            const loadingNotification = { content: 'saving', showProgress: true };
            commitAddNotification(context, loadingNotification);
            const response = (await Promise.all([
                api.updateUser(context.rootState.main.token, payload.id, payload.user),
                await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            // commitSetUser(context, response.data);
            commitRemoveNotification(context, loadingNotification);
            commitAddNotification(context, { content: 'User successfully updated', color: 'success' });
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionCreateUploadImageList(context: MainContext, payload: UploadImageState) {
        const loadingNotification = { content: '保存中', showProgress: true, timeout: 10000 };
        try {
            commitAddNotification(context, loadingNotification);
            const response = (await Promise.all([
                api.createUploadImageList(context.rootState.main.token, payload),
                await new Promise((resolve, reject) => setTimeout(() => resolve(true), 500)),
            ]))[0];
            // commitSetUser(context, response.data);
            commitRemoveNotification(context, loadingNotification);
            commitAddNotification(context, { content: '上传图片成功', color: 'success' });
            return response;
        } catch (error) {
            commitRemoveNotification(context, loadingNotification);
            await dispatchCheckApiError(context, error);
            throw error;
        }
    },
    async actionUpdateOmrTask(context: MainContext, payload: { id: string }) {
        const loadingNotification = { content: '提交请求中', showProgress: true };
        try {
            commitAddNotification(context, loadingNotification);
            const response = (await Promise.all([
                api.updateOmrTask(context.rootState.main.token, payload.id),
                await new Promise((resolve, reject) => setTimeout(() => resolve(true), 500)),
            ]))[0];
            commitRemoveNotification(context, loadingNotification);
            commitAddNotification(context, { content: '成功提交更新任务', color: 'success' });
            return response.data;
        } catch (error) {
            commitRemoveNotification(context, loadingNotification);
            await dispatchCheckApiError(context, error);
            throw error;
        }
    },
    async actionGetUploadImageList(context: MainContext, payload: { id: string }) {
        try {
            const response = await api.getUploadImageScoreList(context.rootState.main.token, payload.id);
            if (response.data) {
                omrStateStore.commitSetImgList(context, response.data.img_list);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
            throw error;
        }
    },
    async actionPatchOmrTask(context: MainContext, payload: OmrTaskState) {
        const loadingNotification = { content: '保存反馈中 Saving feedback', showProgress: true };
        try {
            const response = (await Promise.all([
                api.patchOmrTask(context.rootState.main.token, payload),
                await new Promise((resolve, reject) => setTimeout(() => resolve(true), 500)),
            ]))[0];
            commitRemoveNotification(context, loadingNotification);
            commitAddNotification(context, { content: '成功反馈 Successful feedback', color: 'success' });
            return response;
        } catch (error) {
            commitRemoveNotification(context, loadingNotification);
            await dispatchCheckApiError(context, error);
            throw error;
        }
    },
    async actionGetDealEvent(context: MainContext, payload: { transUUID: string, first: boolean }) {
        const loadingNotification = { content: '等待转谱中', showProgress: true };
        try {
            if (payload.first) {
                commitAddNotification(context, loadingNotification);
            }
            const response = await api.getDealEvent(context.rootState.main.token, payload.transUUID);
            // const response = (await Promise.all([
            //     api.getDealEvent(context.rootState.main.token, payload.trans_uuid),
            //     await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
            // ]))[0];
            if (response.status === 202) {
                return response;
            }
            commitRemoveNotification(context, loadingNotification);
            commitAddNotification(context, { content: '转谱完成', color: 'success' });
            return response;
        } catch (error) {
            commitRemoveNotification(context, loadingNotification);
            await dispatchCheckApiError(context, error);
            throw error;
        }
    },
    async actionGetXmlScore(context: MainContext, payload: { transUUID: string }) {
        const loadingNotification = { content: '下载xml中', showProgress: true };
        try {
            commitAddNotification(context, loadingNotification);
            const response = await api.getXmlScore(context.rootState.main.token, payload.transUUID);
            commitRemoveNotification(context, loadingNotification);
            commitAddNotification(context, { content: '下载完成', color: 'success' });
            return response;
        } catch (error) {
            commitRemoveNotification(context, loadingNotification);
            // await dispatchCheckApiError(context, error);
            throw error;
        }
    },
};

// dispatch
const { dispatch } = getStoreAccessors<OmrState, State>('');
export const dispatchCreateUploadImageList = dispatch(actions.actionCreateUploadImageList);
export const dispatchUpdateOmrTask = dispatch(actions.actionUpdateOmrTask);
export const dispatchGetUploadImageList = dispatch(actions.actionGetUploadImageList);
export const dispatchPatchOmrTask = dispatch(actions.actionPatchOmrTask);
export const dispatchGetOmrTaskList = dispatch(actions.actionGetOmrTaskList);
export const dispatchUpdateUser = dispatch(actions.actionUpdateUser); // TODO

export const dispatchGetDealEvent = dispatch(actions.actionGetDealEvent);
export const dispatchGetXmlScore = dispatch(actions.actionGetXmlScore);
